<script>
    export let lineName;
</script>

<style>
div {
    width: 2em;
    height: 2em;

    background: #eaab00;
    border: 1.7px solid black;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    text-align: center;
    display: flex;

    font-size: 0.9em;
    font-weight: bold;
}
</style>

<div>
{lineName}
</div>